import React from 'react';
import Menu from "semantic-ui-react/dist/es/collections/Menu/Menu.js";
import { buildKeyFromStrings } from "../../../../utils/build-key-from-strings";
export var getMenuItemMarkup = function getMenuItemMarkup(_ref, index) {
  var href = _ref.href,
      text = _ref.text,
      target = _ref.target;
  return React.createElement(Menu.Item, {
    href: href,
    key: buildKeyFromStrings(text, index),
    link: true,
    target: target
  }, text);
};